import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/landing-v4/Nav";
import Hero from "@/components/landing-v4/Hero";
import SocialProof from "@/components/landing-v4/SocialProof";
import Problem from "@/components/landing-v4/Problem";
import WhyCreatorMarketing from "@/components/landing-v4/WhyCreatorMarketing";
import WhatIBuild from "@/components/landing-v4/WhatIBuild";
import ContentShowcase from "@/components/landing-v4/ContentShowcase";
import HowWeWork from "@/components/landing-v4/HowWeWork";
import Pricing from "@/components/landing-v4/Pricing";
import WhatsIncluded from "@/components/landing-v4/WhatsIncluded";
import WhyDifferent from "@/components/landing-v4/WhyDifferent";
import CaseStudy from "@/components/landing-v4/CaseStudy";
import Testimonials from "@/components/landing-v4/Testimonials";
import IdealClient from "@/components/landing-v4/IdealClient";
import About from "@/components/landing-v4/About";
import FAQ from "@/components/landing-v4/FAQ";
import FinalCTA from "@/components/landing-v4/FinalCTA";
import Footer from "@/components/landing-v4/Footer";

export default function Home() {
    const { hash } = useLocation();

    useEffect(() => {
        if (!hash) return;
        const id = hash.replace("#", "");
        const t = setTimeout(() => {
            const el = document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 120);
        return () => clearTimeout(t);
    }, [hash]);

    return (
        <main className="relative overflow-x-clip">
            <Nav />
            <Hero />
            <SocialProof />
            <Problem />
            <WhyCreatorMarketing />
            <WhatIBuild />
            <ContentShowcase />
            <HowWeWork />
            <Pricing />
            <WhatsIncluded />
            <WhyDifferent />
            <CaseStudy />
            <Testimonials />
            <IdealClient />
            <About />
            <FAQ />
            <FinalCTA />
            <Footer />
        </main>
    );
}
